import { Route } from 'react-router';
import { lazyPage } from '../../shell/lazyPage';

const LoginPage = lazyPage(() => import('./LoginPage.tsx'), 'LoginPage');
const ForgotPasswordPage = lazyPage(() => import('./ForgotPasswordPage.tsx'), 'ForgotPasswordPage');
const ResetPasswordPage = lazyPage(() => import('./ResetPasswordPage.tsx'), 'ResetPasswordPage');

export const identityRoutes = (
    <>
        <Route path="login" lazy={LoginPage} />
        <Route path="forgotPassword" lazy={ForgotPasswordPage} />
        <Route path="resetPassword" lazy={ResetPasswordPage} />
    </>
);
